import { createContext } from "react";

const AllProductContext = createContext();

export default AllProductContext;
